import getDayOfWeekLabel from 'modules/core/lib/getDayOfWeekLabel'

export default function dayOfWeek(list: string[]): string[] {
  return list.map((key: string) => {
    return getDayOfWeekLabel(key)
  })
}
